import Chart from 'chart.js/auto'

export const runCharts = () => {

  const els = document.querySelectorAll('.chart__canvas')

	if (!els.length) return

  els.forEach((el) => {
    const ctx = el
		const title = el.dataset.title
		const labels = el.dataset.labels
		const before = el.dataset.before
		const after = el.dataset.after
		const scalesTitle = el.dataset.scalesTitle
		const stepSize = el.dataset.stepSize
		const maxSize = el.dataset.maxSize

		console.log('Title', title)

    Chart.defaults.backgroundColor = '#FCFAF9'
    Chart.defaults.borderColor = 'rgba(0, 56, 28, 0.2)'
    Chart.defaults.color = '#00381C'

    const data = {
      labels: JSON.parse(labels),
      datasets: [
        {
          label: 'Before (without CHRIS System)',
          data: JSON.parse(before),
          backgroundColor: 'rgba(0, 56, 28, 1)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 0,
        },
        {
          label: 'After (with CHRIS System)',
          data: JSON.parse(after),
          backgroundColor: 'rgba(215, 100, 71, 1)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 0,
        },
      ],
    }

    const chart = new Chart(ctx, {
      type: 'bar',
      data: data,
      options: {
				maintainAspectRatio: false,
        scales: {
          x: {
            // barPercentage: 1.0,
            // categoryPercentage: 0.6,
            title: {
              display: true,
              font: {
                size: 24,
              },
            },
          },
          y: {
            beginAtZero: true,
            max: Number(maxSize),
            ticks: {
              stepSize: Number(stepSize),
							font: {
								size: 16
							}
            },
            title: {
              display: true,
              text: scalesTitle,
              font: {
                size: 24,
                family: '"Monument Grotesk", sans-serif',
              },
            },
          },
        },
        plugins: {
					tooltip: {
						enabled: false,
						callbacks: {
							label: (item) => `${item.dataset.label}: ${item.formattedValue}W`,
						},
					},
          legend: {
            position: 'top',
            labels: {
              font: {
                size: 16,
                family: '"Monument Grotesk", sans-serif',
              },
            },
          },
          title: {
            display: true,
            text: title,
            font: {
              family: '"Monument Grotesk", sans-serif',
              size: 32,
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'top',
            formatter: Math.round,
            font: {
              weight: 'bold',
            },
          },
        },
      },
    })
  })
}

export default () => {}
